/**
 * nt-marquee.js
 * Drives every [data-nt-strip] element: slow auto-scroll, pauses on hover,
 * and can be dragged with mouse/touch. Each item is rendered once; the
 * track scrolls back and forth between its two ends instead of looping.
 */
(function () {
  'use strict';

  function initStrip(wrap) {
    if (wrap.dataset.ntBound) return;
    wrap.dataset.ntBound = 'true';

    var track = wrap.querySelector('[data-nt-strip-track]');
    if (!track) return;

    var state = { pos: 0, dir: 1, dragging: false, dragStartX: 0, dragStartPos: 0, hover: false };

    function maxPos() {
      return Math.max(0, track.scrollWidth - wrap.clientWidth);
    }

    function down(e) {
      state.dragging = true;
      state.dragStartX = e.clientX;
      state.dragStartPos = state.pos;
      wrap.style.cursor = 'grabbing';
      try { wrap.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
    }
    function move(e) {
      if (!state.dragging) return;
      var pos = state.dragStartPos - (e.clientX - state.dragStartX);
      state.pos = Math.min(Math.max(pos, 0), maxPos());
      track.style.transform = 'translateX(' + (-pos) + 'px)';
    }
    function up() {
      if (!state.dragging) return;
      state.dragging = false;
      wrap.style.cursor = 'grab';
    }
    function enter() { state.hover = true; }
    function leave() { state.hover = false; up(); }

    wrap.addEventListener('pointerdown', down);
    wrap.addEventListener('pointermove', move);
    wrap.addEventListener('pointerup', up);
    wrap.addEventListener('pointercancel', up);
    wrap.addEventListener('mouseenter', enter);
    wrap.addEventListener('mouseleave', leave);

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion) {
      var raf;
      var tick = function () {
        if (!state.dragging && !state.hover) {
          var max = maxPos();
          state.pos += 0.4 * state.dir;
          if (state.pos >= max) { state.pos = max; state.dir = -1; }
          else if (state.pos <= 0) { state.pos = 0; state.dir = 1; }
          track.style.transform = 'translateX(' + (-state.pos) + 'px)';
        }
        raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    }
  }

  document.querySelectorAll('[data-nt-strip]').forEach(initStrip);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-nt-strip]').forEach(initStrip);
  });
})();
